import { gql } from '@apollo/client'
import {
  Docview,
  RecommendedDocuments,
  ViewLockContext,
  ViewLockWrapper,
} from '@jusbrasil-web/docview/core'

import {
  ArticleNewsDocument,
  ArticleNewsMetaTags,
  ArticleNewsToolbar,
  Comments,
  ModerationBanner,
  PublicationAppbar,
  PublicationHeader,
  PublicationSidebar,
} from '../../components'
import { SegmentationProvider } from '../../hooks/segmentation-hook'

export const ArticleRoot = gql`
  query articleRoot($docId: NumericID!, $isNewsPage: Boolean!) {
    root {
      document: documentByNumericID(docId: $docId, artifact: "ARTIGO") {
        docId
        url
        slug
        status
        isActive
        hasCreditsToViewDocument: viewerCanUseFeature(featureCode: "view_lr_content_1000")
        readingTime

        ...ArticleNewsToolbar_document
        ...PublicationHeader_document
        ...PublicationAppbar_document
        ...ArticleNewsDocument_document
        ...PublicationSidebar_document
        ...Docview_document
        ...RecommendedDocuments_document
        ...Comments_document
        ...ViewLockContext_document
        ...ViewLockWrapper_document
        ...ModerationBanner_document
        ...ArticleNewsMetaTags_document
        ...SegmentationProvider_document
      }

      viewer: me {
        pid
        boxProfileInfo {
          linkedAccount
        }
        hasPaidPlan
        viewContentBlocked: isBlockedFeature(featureCode: "view_lr_content_1000")

        ...ArticleNewsToolbar_viewer
        ...PublicationHeader_viewer
        ...Docview_viewer
        ...Comments_viewer
        ...ViewLockContext_viewer
        ...ViewLockWrapper_viewer
        ...ModerationBanner_viewer
      }
    }
  }

  ${ArticleNewsToolbar.fragments.document}
  ${PublicationHeader.fragments.document}
  ${PublicationAppbar.fragments.document}
  ${ArticleNewsDocument.fragments.document}
  ${Docview.fragments.document}
  ${PublicationSidebar.fragments.document}
  ${RecommendedDocuments.fragments.document}
  ${Comments.fragments.document}
  ${ViewLockContext.fragments.document}
  ${ViewLockWrapper.fragments.document}
  ${ModerationBanner.fragments.document}
  ${ArticleNewsMetaTags.fragments.document}
  ${SegmentationProvider.fragments.document}

  ${ArticleNewsToolbar.fragments.viewer}
  ${PublicationHeader.fragments.viewer}
  ${Docview.fragments.viewer}
  ${Comments.fragments.viewer}
  ${ViewLockContext.fragments.viewer}
  ${ViewLockWrapper.fragments.viewer}
  ${ModerationBanner.fragments.viewer}
`
